import { FilterObject, SortOrder } from "./DataHandler.js";
import { DataObject } from "./DataObject.js";

export class RecordSource<T extends Record<string, unknown>> {
	private dataObject: DataObject<T>;
	constructor(dataObject: DataObject<T>) {
		this.dataObject = dataObject;
	}

	getMaxRecords = () => this.dataObject.getParameter("maxRecords");
	getSortOrder = () => this.dataObject.getParameter("sortOrder");
	getFilterString = () => this.dataObject.getParameter("filterString");
	getFilterObject = () => this.dataObject.getParameter("filterObject");
	getWhereClause = () => this.dataObject.getParameter("whereClause");
	getWhereObject = () => this.dataObject.getParameter("whereObject");
	setMaxRecords = (value: number) => this.dataObject.setParameter("maxRecords", value);
	setSortOrder = (value: Record<keyof T, SortOrder>[]) => this.dataObject.setParameter("sortOrder", value);
	setFilterString = (value: string) => this.dataObject.setParameter("filterString", value);
	setFilterObject = (value: FilterObject | null) => this.dataObject.setParameter("filterObject", value);
	setWhereClause = (value: string) => this.dataObject.setParameter("whereClause", value);
	setWhereObject = (value: FilterObject | null) => this.dataObject.setParameter("whereObject", value);
}
